import backupplans from "./backupplans.component";
import backupplansUrls from "./backupplans.urls";
import BackupplansTransforms from "./backupplans.transforms";

const backupplansModule = angular
  .module("app.components.backupplans", [])
  .component("backupplansPage", backupplans)
  .service("BackupplansTransforms", BackupplansTransforms)
  .config(backupplansUrls);

export default backupplansModule;



// WEBPACK FOOTER //
// ./src/pages/backupplans/backupplans.module.js